import Vue from "vue";
import VueRouter from "vue-router";
import {
  getToken,
  checkIfLoggedIn,
  clearCookies,
  showToast,
} from "../utils/helpers";
import { registerPlugin } from "@capacitor/core";
import store from "../store";
const NotificationPlugin = registerPlugin("NotificationPlugin");

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("../views/loginPage.vue"),
  // },
  // {
  //   path: "/bfb050d3-2d74-4451-96cf-c8ae8f0b792a",
  //   name: "bfb050d3-2d74-4451-96cf-c8ae8f0b792a",
  //   component: () => import("../views/loginPage.vue"),
  // },
  {
    path: "/",
    component: () => import("../views/loginPage.vue"),
    redirect: "/login",
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../views/loginPage.vue"),
      },
    ],
  },
  // {
  //   path: "/",
  //   component: () => import("../views/VisitBack.vue"),
  //   redirect: "/visitback",
  //   children: [
  //     {
  //       path: "visitback",
  //       name: "visitback",
  //       component: () => import("../views/VisitBack.vue"),
  //     },
  //   ],
  // },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    component: () => import("../views/VerifyEmail.vue"),
  },
  {
    path: "/forgot",
    name: "forgot",
    component: () => import("../views/ForgotWeb.vue"),
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("../views/ResetPassword.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach(async (to, from, next) => {
  document.title = `Hire3x`;
  try {
    const { notification } = await NotificationPlugin.getCurrentNotification();
    if (notification)
      store.commit(
        "userVUEX/setNotificationRedirect",
        JSON.parse(notification).nameValuePairs
      );
    await NotificationPlugin.clearCurrentNotification();
  } catch (error) {
    console.log("No current notification", error);
  }
  let userdata = localStorage.getItem("simpAdminState") || null;
  let userval = userdata ? JSON.parse(userdata).userVUEX.userData : {};
  if (to.name == "login" && to.query.uuid && to.query.resumeclinic) {
    localStorage.clear();
    clearCookies();
  }
  if (
    (to.name == "verify" && to.query.type == "verify") ||
    to.name == "reset"
  ) {
    if (Object.keys(userval).length == 0) {
      next({ name: "login" });
    }
  }
  let isLaptop = window.innerWidth >= 1024 ? true : false;
  // next();
  if (!getToken()) {
    clearCookies();
    next();
  } else {
    showToast("In redirect");
    checkIfLoggedIn(to, isLaptop, next);
  }
  // else{
  //   // clearCookies();
  //   next();
  // }
});
